import type { ReactNode } from 'react'
import { Icon, type IconName } from './Icon'

export function EmptyState({
  icon,
  eyebrow,
  title,
  description,
  actions,
  compact = false,
}: {
  icon: IconName
  eyebrow?: string
  title: string
  description: string
  actions?: ReactNode
  compact?: boolean
}) {
  return (
    <div className={`guided-empty-state${compact ? ' compact' : ''}`}>
      <span className="guided-empty-icon" aria-hidden="true"><Icon name={icon} size={20} /></span>
      <div className="guided-empty-copy">
        {eyebrow ? <p className="eyebrow">{eyebrow}</p> : null}
        <h2>{title}</h2>
        <p>{description}</p>
      </div>
      {actions ? <div className="guided-empty-actions">{actions}</div> : null}
    </div>
  )
}
